(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('fleetFilter', fleetFilter);

    function fleetFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                objectClazz: '&',
                objectClazzVal: '&'
            },
            template:   '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                       <div class="row">\n' +
            '                            <div class="col-xs-5">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label for="field_class">Object Class</label>\n' +
            '                                       <ui-select ng-model="vm.objectClazz" id="objectClass_field" theme="bootstrap">\n' +
            '                                       <ui-select-match\n' +
            '                                           placeholder="Select or search an object class...">\n' +
            '                                           {{$select.selected.className}}\n' +
            '                                       </ui-select-match>\n' +
            '                                       <ui-select-choices repeat="item in vm.objectClass | filter: {className: $select.search}">\n' +
            '                                           <div ng-bind-html="item.className | highlight: $select.search"></div>\n' +
            '                                       </ui-select-choices>\n' +
            '                                       </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2 inline-filter-button">\n' +
            '                                <div class="form-group">\n' +
            '                                    <label class="control-label ng-scope" for="submit_field"></label>\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                       </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>\n',
            controller: FleetFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    FleetFilterController.$inject = ['ObjectClass'];

    function FleetFilterController(ObjectClass) {
        var vm=this;
        ObjectClass.query(onSuccess, onError);

        function onSuccess(data) {
            vm.objectClass = data;
            vm.objectClass.unshift(allObjectClass);
            // vm.objectClazz = allObjectClass;
        }

        function onError() {}

        var allObjectClass = {
            id: -1,
            className: "All"
        };

        vm.objectClazz = +vm.objectClazzVal() === -1 || vm.objectClazzVal().id === -1 ? allObjectClass : vm.objectClazzVal();

        vm.submit = function () {
            vm.filter({ objectClazz: vm.objectClazz });
        };
    }
})();
